<div class="footer flex flex-wrap elevation-2 surface-container-high border-t">
    <div class="w-full sm:w-1/2 p-3 flex flex-row justify-center sm:justify-start items-center gap-5">
        <span class="text-muted">
            Copyright <i class="fa-solid fa-copyright"></i> {{currentYear}}, groupworkguru.com
        </span>
        
        <span class="text-muted">
            ABN 98 252 195 833
        </span>
    </div>

    <div class="w-full sm:w-1/2 p-3 flex flex-row justify-center sm:justify-end items-center gap-5">

        <a target="_blank" href="https://docs.groupworkguru.com/privacy">Privacy Statement</a>

        <a target="_blank" href="https://docs.groupworkguru.com/terms">Terms of Use</a>

        <a href="mailto:admin@groupworkguru.com">Contact us</a>
    </div>
</div>
